"use strict";

exports.__esModule = true;
var _ReportingPeriodSelector = require("./ReportingPeriodSelector");
Object.keys(_ReportingPeriodSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportingPeriodSelector[key]) return;
  exports[key] = _ReportingPeriodSelector[key];
});